import {adminHttpClient} from "../commons/adminHttpClient";

const getAdvertisementAuditView = (id : string) : Promise<any> => {
    return adminHttpClient.get(`/AdvertisementAudits/View/${id}`);
}

export default getAdvertisementAuditView